// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.85.0-beta.dfda0f2e8',
  revision: 'dfda0f2e8',
  branch: 'develop',
  date: 'Fri, 13 Feb 2026 21:01:41 GMT'
};